import type { IconData } from '@stacksjs/iconify-core'

export const pinterestSquare: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M9.355 11.614C9.1 12.99 8.79 14.31 7.866 15c-.284-2.08.419-3.644.745-5.303c-.556-.964.067-2.906 1.24-2.427c1.445.588-1.25 3.586.56 3.96c1.888.392 2.66-3.374 1.488-4.6c-1.692-1.768-4.927-.04-4.529 2.492c.097.62.718.807.248 1.661c-1.083-.247-1.406-1.127-1.365-2.3c.067-1.92 1.675-3.263 3.289-3.45c2.04-.235 3.954.772 4.219 2.748c.297 2.23-.921 4.646-3.103 4.472c-.59-.047-.84-.35-1.303-.64z\"/><path d=\"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pinterestSquare
